export default __webpack_public_path__ + "static/media/c-sm-logo.367d9329.png";